// Google Maps
export let googlePlacesAutocompleteLoaded = false;
const readyListeners = new Set<() => void>();
let loading = false;
const callbackName = "__forslerGooglePlacesReady";

export function onGooglePlacesReady(callback: () => void) {
  if (window.google?.maps?.places) {
    callback();
    return () => {};
  }
  readyListeners.add(callback);
  return () => { readyListeners.delete(callback); };
}

export function loadGooglePlacesAutocompleteScript(apiKey: string, callback: () => void) {
  if (window.google?.maps?.places) {
    googlePlacesAutocompleteLoaded = true;
    callback();
    return;
  }

  onGooglePlacesReady(callback);
  if (loading) return;
  loading = true;

  const script = document.createElement("script");
  const callbacks = window as unknown as Record<string, unknown>;
  const fail = () => {
    loading = false;
    delete callbacks[callbackName];
    script.remove();
    console.error("Could not load Google Maps Places API library.");
  };
  callbacks[callbackName] = () => {
    if (!window.google?.maps?.places) {
      fail();
      return;
    }
    googlePlacesAutocompleteLoaded = true;
    loading = false;
    delete callbacks[callbackName];
    const listeners = Array.from(readyListeners);
    readyListeners.clear();
    listeners.forEach((listener) => listener());
  };
  script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&loading=async&libraries=places&callback=${callbackName}`;
  script.async = true;
  script.onerror = fail;
  document.head.appendChild(script);
}
